import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';

import { RenderVideoComponent } from './render-video.component';


@NgModule({
  declarations: [
    RenderVideoComponent
  ],
  imports: [
    CommonModule,
    LazyLoadModule,
  ],
  exports: [
    RenderVideoComponent
  ]
})
export class RenderVideoModule { }
